export const companyName = 'гарантирования жилищного строительства';
export const companyName2 = 'АО "Фонд гарантирования жилищного строительства"';

export function getMonthName(index: number, isShortName?: boolean, isUpperCase?: boolean) {
  const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
  let month: string = '';
  if (isShortName) {
    month = months[index - 1].substring(0, 3);
  } else {
    month = months[index - 1];
  }
  if (isUpperCase) {
    return month.toUpperCase();
  } else {
    return month;
  }
}
